export const pathObj = {
  LOGIN: "/v1/user/login",
  FORGOT_PASSWORD: "/v1/user/forgot-password",
  RESET_PASSWORD: "/v1/user/reset-password",
  USER_LIST: "/v1/admin/user",
  DASHBOARD_LIST: "/v1/admin/user/dashboard-api",
  USER_ADD: "/v1/admin/user/add-user",
  USER_EDIT: "/v1/admin/user",
  USER_VIEW: "/v1/admin/user",
  CHANGE_USER_STATUS: "/v1/admin/user/change-status",
  DELETE_USER: "/v1/admin/user",
  SIGNUP: "/v1/user/signup",
  CONTACT_US: "/v1/user/contact-us",
  TEAM: "/v1/admin/volentier",
  DELETE_TEAM: "/v1/admin/volentier",
  EVENT_LIST: "/v1/admin/event",
  CHANGE_EVENT_STATUS: "/v1/admin/event/change-status",
  EVENT_ADD: "/v1/admin/event",
  EVENT_EDIT: "/v1/admin/event",
  DELETE_EVENT: "/v1/admin/event",
  EVENT_USER_LIST: "/v1/user/event",
  CHANGE_EVENT_STATUS: "/v1/admin/event/change-status",
  ALL_EVENT_USER_LIST: "/v1/user/event/all-events",
  ADD_TEAM: "/v1/admin/volentier/add-volentier",
  EDIT_TEAM: "/v1/admin/volentier",
  PAYMENT_LIST: "/v1/admin/user/user-not-registered-list",
  ACCEPT_REJECT: "/v1/admin/user/approve-reject",
  GET_SUVICHAR: "/v1/user/suvichar",
  DELETE_SUVICHAR: "/v1/user/suvichar",
  ADD_SUVICHAR: "/v1/user/suvichar/add-suvichar",
  EDIT_SUVICHAR: "/v1/user/suvichar",
  GET_EMPLOYMENT: "/v1/user/employment",
  ADD_EMPLOYMENT: "/v1/user/employment/add-employment",
  EDIT_EMPLOYMENT: "/v1/user/employment",
  DELETE_EMPLOYMENT: "/v1/user/employment",
  ADD_BIO_DATA: "/v1/user/marital/add-marital",
  ADD_INTEREST_MATRIMONIAL: "/v1/user/interestmatrimonial",
  INTEREST_MATRIMONIAL_LIST: "/v1/admin/interestmatrimonial",
  MARITAL_LIST: "/v1/user/marital",
  SUGGESTION: "/v1/user/suggestion",
  GET_SUGGESTION: "/v1/user/suggestion",
  GET_CONTACT_US: "/v1/user",
};
